import { z } from "zod";

// Define the password schema using Zod

export const phoneSchema = z
  .string()
  .min(10, "Phone number must be 10 digits")
  .max(11, "Phone number must be 11 digits")
  .refine((value) => /[0-9]{10}/.test(value), {
    message: "Phone number must contain at only digits",
  });

export const passwordSchema = z
  .string({ message: "Password must be provided" })
  .min(8, { message: "Password must be at least 8 characters long" })
  .refine((value) => /[A-Z]/.test(value), {
    message: "Password must contain at least one uppercase letter",
  })
  .refine((value) => /[a-z]/.test(value), {
    message: "Password must contain at least one lowercase letter",
  })
  .refine((value) => /[0-9]/.test(value), {
    message: "Password must contain at least one number",
  })
  .refine((value) => /[@$!%*?&#]/.test(value), {
    message: "Password must contain at least one special symbol (@$!%*?&#)",
  });

export const userNameSchema = z
  .string()
  .min(6, { message: "User name must be at least 6 characters long" })
  .refine((value) => /[A-Za-z0-9]/.test(value), {
    message: "User name may contain one uppercase/lowercase/numbers letter",
  })
  .refine((value) => !/[-=\[\];',/~!#$%^&*()_+{}:"<>\\?]/.test(value), {
    message: "User name must not contain a special symbol ($!%*?&#)",
  });

export const supportAmountSchema = z
  .number()
  .min(
    +process.env.NEXT_PUBLIC_MINIMUM_SUPPORT_AMOUNT!,
    `Minimum amount should be ₹ ${process.env.NEXT_PUBLIC_MINIMUM_SUPPORT_AMOUNT}`,
  )
  .max(
    +process.env.NEXT_PUBLIC_MAXIMUM_SUPPORT_AMOUNT!,
    `Maximum amount can be ₹ ${process.env.NEXT_PUBLIC_MAXIMUM_SUPPORT_AMOUNT}`,
  )
  .refine((value) => !(value % 1 != 0), {
    message: "Amount should not contain decimal value",
  });

const panCardRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

const validFourthChars = ["P", "C", "H", "A", "B", "G", "J", "L", "F", "T"];

export const panSchema = z
  .string({ message: "PAN number is mandatory" })
  .length(10, { message: "PAN number must be exactly 10 characters" })
  .regex(panCardRegex, { message: "Invalid PAN format" })
  .refine((val) => validFourthChars.includes(val[3]), {
    message: "Invalid 4th character in PAN (invalid PAN holder type)",
  });

// IFSC code format: 4 letters + 0 + 6 alphanumeric
export const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const ifscCodeSchema = z.string().regex(ifscRegex, {
  message: "Invalid IFSC code format",
});

// Account number: typically 9 to 18 digits
export const accountNumberRegex = /^\d{9,18}$/;
export const accountNumberSchema = z
  .string({
    message: "Account number is mandatory",
  })
  .regex(accountNumberRegex, {
    message: "Account number must be 9 to 18 digits",
  });

// Beneficiary name: only letters and spaces, minimum 2 characters
export const nameRegex = /^[A-Za-z ]{2,}$/;
export const beneficiaryNameSchema = z.string().regex(nameRegex, {
  message: "Name must contain only letters and spaces (min 2 characters)",
});

const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const gstNumberSchema = z
  .string({ message: "GST number is mandatory" })
  .length(15, { message: "GST number must be 15 characters long" })
  .regex(gstRegex, { message: "Invalid GST number format" });

export const optionalGSTNumberSchema = z
  .string({ message: "GST number is mandatory" })
  .regex(gstRegex, { message: "Invalid GST number format" })
  .nullable();
